import script from "./addSN.vue?vue&type=script&lang=ts&setup=true"
export * from "./addSN.vue?vue&type=script&lang=ts&setup=true"

import "./addSN.vue?vue&type=style&index=0&id=47b2af79&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b2af79"]])

export default __exports__